(function () {
  const WISHLIST_KEY = 'nukh_wishlist';

  // Get wishlist
  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || [];
    } catch (error) {
      return [];
    }
  }

  // Save wishlist
  function saveWishlist(wishlist) {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(wishlist));

    // Notify other wishlist components
    document.dispatchEvent(
      new CustomEvent('wishlist:updated', {
        detail: { wishlist: wishlist }
      })
    );
  }

  // Check whether a product is in wishlist
  function isInWishlist(productHandle) {
    return getWishlist().some(
      (item) => item.handle === productHandle
    );
  }

  // Update wishlist count in the header
function updateWishlistCount() {
  const wishlistCount = getWishlist().length;

  document.querySelectorAll('[data-wishlist-count]').forEach((countElement) => {
    countElement.textContent = wishlistCount;

    if (wishlistCount > 0) {
      countElement.classList.add('has-items');
      countElement.setAttribute('aria-hidden', 'false');
    } else {
      countElement.classList.remove('has-items');
      countElement.setAttribute('aria-hidden', 'true');
    }
  });
}

  // Add product
  function addToWishlist(product) {
    const wishlist = getWishlist();

    if (!isInWishlist(product.handle)) {
      wishlist.push(product);
      saveWishlist(wishlist);
    }

    return wishlist;
  }

  // Remove product
  function removeFromWishlist(productHandle) {
    const wishlist = getWishlist().filter(
      (item) => item.handle !== productHandle
    );

    saveWishlist(wishlist);
    return wishlist;
  }

  // Toggle product
  function toggleWishlist(product) {
    if (isInWishlist(product.handle)) {
      return removeFromWishlist(product.handle);
    }

    return addToWishlist(product);
  }

  // Make functions available globally
  window.NUKHWishlist = {
    get: getWishlist,
    save: saveWishlist,
    has: isInWishlist,
    add: addToWishlist,
    remove: removeFromWishlist,
    toggle: toggleWishlist
  };

  // Update all wishlist buttons
  document.addEventListener('wishlist:updated', function () {
  document.querySelectorAll('[data-wishlist-button]').forEach((button) => {
    const handle = button.dataset.productHandle;

    if (handle && isInWishlist(handle)) {
      button.classList.add('is-wishlisted');
      button.setAttribute('aria-pressed', 'true');
    } else {
      button.classList.remove('is-wishlisted');
      button.setAttribute('aria-pressed', 'false');
    }
  });

  updateWishlistCount();
});
    // Handle wishlist button clicks
  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-wishlist-button]');

    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    const product = {
      handle: button.dataset.productHandle,
      title: button.dataset.productTitle,
      url: button.dataset.productUrl,
      image: button.dataset.productImage,
      price: button.dataset.productPrice
    };

    if (!product.handle) return;

    toggleWishlist(product);

    // Update all wishlist buttons
    document.querySelectorAll('[data-wishlist-button]').forEach((wishlistButton) => {
      const handle = wishlistButton.dataset.productHandle;

      if (handle && isInWishlist(handle)) {
        wishlistButton.classList.add('is-wishlisted');
        wishlistButton.setAttribute('aria-pressed', 'true');
      } else {
        wishlistButton.classList.remove('is-wishlisted');
        wishlistButton.setAttribute('aria-pressed', 'false');
      }
    });
  });

  // Set the correct state when the page first loads
  document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-wishlist-button]').forEach((button) => {
    const handle = button.dataset.productHandle;

    if (handle && isInWishlist(handle)) {
      button.classList.add('is-wishlisted');
      button.setAttribute('aria-pressed', 'true');
    }
  });

  updateWishlistCount();
});
    
  // Render wishlist page
  function renderWishlistPage() {
    const wishlistContainer = document.querySelector('[data-wishlist-page]');

    if (!wishlistContainer) return;

    const wishlist = getWishlist();

    if (wishlist.length === 0) {
      wishlistContainer.innerHTML = `
        <div class="nukh-wishlist-empty">
          <div class="nukh-wishlist-empty-icon">
            <svg
              width="48"
              height="48"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <path
                d="M20.84 4.61C19.87 3.63 18.56 3.08 17.19 3.08C15.82 3.08 14.51 3.63 13.54 4.61L12 6.16L10.46 4.61C9.49 3.63 8.18 3.08 6.81 3.08C5.44 3.08 4.13 3.63 3.16 4.61C1.15 6.64 1.15 9.93 3.16 11.96L12 20.92L20.84 11.96C22.85 9.93 22.85 6.64 20.84 4.61Z"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>

          <h2>Your Wishlist is Empty</h2>

          <p>
            Save your favourite pieces here and come back to them anytime.
          </p>

          <a href="{{ routes.all_products_collection_url }}" class="nukh-wishlist-continue">
            Continue Shopping
          </a>
        </div>
      `;

      return;
    }

    wishlistContainer.innerHTML = `
      <div class="nukh-wishlist-grid">
        ${wishlist.map((item) => `
          <div
            class="nukh-wishlist-item"
            data-wishlist-item="${item.handle}"
          >
            <div class="nukh-wishlist-image-wrapper">

              <a
                href="${item.url}"
                class="nukh-wishlist-image-link"
              >
                ${
                  item.image
                    ? `<img
                        src="${item.image}"
                        alt="${item.title}"
                        class="nukh-wishlist-image"
                        loading="lazy"
                      >`
                    : ''
                }
              </a>

              <button
                type="button"
                class="nukh-wishlist-remove"
                data-wishlist-remove="${item.handle}"
                aria-label="Remove ${item.title} from wishlist"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                >
                  <path
                    d="M18 6L6 18M6 6L18 18"
                    stroke="currentColor"
                    stroke-width="1.7"
                    stroke-linecap="round"
                  />
                </svg>
              </button>

            </div>

            <div class="nukh-wishlist-product-info">

              <a
                href="${item.url}"
                class="nukh-wishlist-product-title"
              >
                ${item.title}
              </a>

              ${
                item.price
                  ? `<div class="nukh-wishlist-price">
                      ${formatWishlistPrice(item.price)}
                    </div>`
                  : ''
              }

              <a
                href="${item.url}"
                class="nukh-wishlist-view-product"
              >
                View Product
              </a>

            </div>
          </div>
        `).join('')}
      </div>
    `;

    bindWishlistRemoveButtons();
  }

  // Format wishlist price
  function formatWishlistPrice(price) {
    const amount = Number(price) / 100;

    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      maximumFractionDigits: 0
    }).format(amount);
  }

  // Bind remove buttons
  function bindWishlistRemoveButtons() {
    document.querySelectorAll('[data-wishlist-remove]').forEach((button) => {
      button.addEventListener('click', function () {
        const handle = this.dataset.wishlistRemove;

        if (!handle) return;

        removeFromWishlist(handle);
      });
    });
  }

  // Render wishlist on page load
  document.addEventListener('DOMContentLoaded', function () {
    renderWishlistPage();
  });

  // Re-render wishlist when products are added or removed
  document.addEventListener('wishlist:updated', function () {
    renderWishlistPage();
  });
})();